import React from 'react';
import PropTypes from 'prop-types';

import Button, { BUTTON_TYPES } from 'pages/MyAccount/shared-components/Button/Button';
import env from '../../utils/env';
import Order from './Order';
import styles from './styles.module.scss';

const SUPPORT_LINK = `https://support.${env.hostname}/`;

const OrdersList = ({
  orders,
  isDesktop,
  onClickAllInvoices,
  onClickOrderDetails,
  trackOrderViewed,
  trackShipment,
}) => (
  <div className={styles.ordersList}>
    <div className={styles.header}>
      <div className={styles.headerTitle} data-testid="order-header">
        <h1>Orders</h1>
        <p>
          {/* eslint-disable-next-line max-len */}
          This is where you’ll find anything you’ve bought from FabFitFun. If you have any questions, please reach out to
          {' '}
          <a href={SUPPORT_LINK} rel="noreferrer" target="_blank" data-testid="customer-care-link"> Customer Care</a>
          .
        </p>
      </div>
      <Button
        buttonType={BUTTON_TYPES.PRIMARY_INVERSE}
        className={styles.button}
        onClick={onClickAllInvoices}
        dataTestId="all-invoices-btn"
      >
        All Invoices
      </Button>
    </div>
    <div className={styles.orders}>
      {orders.map((order, index) => (
        <Order
          key={order.billingDate + order.orderTotalInCents}
          order={order}
          index={index}
          isDesktop={isDesktop}
          onClickOrderDetails={onClickOrderDetails}
          trackOrderViewed={trackOrderViewed}
          trackShipment={trackShipment}
        />
      ))}
    </div>
  </div>
);

OrdersList.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({})),
  isDesktop: PropTypes.bool.isRequired,
  onClickAllInvoices: PropTypes.func.isRequired,
  onClickOrderDetails: PropTypes.func.isRequired,
  trackOrderViewed: PropTypes.func.isRequired,
  trackShipment: PropTypes.func.isRequired,
};

OrdersList.defaultProps = {
  orders: [],
};

export default OrdersList;
